module.exports = __webpack_public_path__ + "img/point_icon.e6fbba31.svg";